<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplineScheduleOutside',
})
</script>

<template>
  <div class="discipline-schedule-outside">
    <div class="discipline-schedule-outside__legend" />
    <AppText
      name="body2"
      color="slate-900"
    >
      - Time slot is outside of tutor's schedule. Lesson will be created with status "planned"
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineScheduleOutside.scss" />
